/**
 * L'avviso del filtro spam sopra un messaggio in arrivo: «sembra una truffa»,
 * «probabile spam», oppure «salvata dallo spam». Dice perché, e lascia
 * decidere: nessun messaggio sparisce senza spiegazione.
 */
import { Ban, CheckCircle2, ShieldAlert, ShieldCheck, TriangleAlert } from 'lucide-react';
import { Button } from '@/components/ui/button';
import { cn } from '@/lib/utils';
import type { AvvisoSicurezza } from '@/lib/api/endpoints';
import { Motivi, RIQUADRI } from './Verdetto';

export function AvvisoMessaggio({
  avviso, onSpam, onSicura, occupato,
}: {
  avviso: AvvisoSicurezza;
  onSpam: () => void;
  onSicura: () => void;
  occupato?: boolean;
}) {
  const rosso = avviso.kind === 'danger';
  const rimessa = avviso.kind === 'rescued';
  const tono = rimessa ? 'azzurro' : rosso ? 'rosso' : 'ambra';
  const Icona = rimessa ? ShieldCheck : rosso ? ShieldAlert : TriangleAlert;
  const titolo = rimessa
    ? 'Salvata dallo spam: il filtro ha giudicato che è posta vera'
    : rosso
      ? 'Attenzione: sembra una truffa (phishing)'
      : 'Probabile spam';

  return (
    <div className={cn('rounded-lg border p-4 space-y-3', RIQUADRI[tono])} role="alert">
      <div className="flex items-center gap-2 text-sm font-medium">
        <Icona className="h-4 w-4 flex-shrink-0" />
        {titolo}
      </div>
      <Motivi motivi={avviso.reasons} />
      {!rimessa && rosso && (
        <p className="text-xs text-muted-foreground">
          Non cliccare i link, non aprire gli allegati e non rispondere con dati personali o di pagamento.
        </p>
      )}
      <div className="flex flex-wrap gap-2">
        <Button size="sm" variant={rosso ? 'default' : 'outline'} onClick={onSpam} disabled={occupato}>
          <Ban className="h-4 w-4 mr-1.5" /> {rimessa ? 'Era spam' : 'È spam'}
        </Button>
        {!rimessa && (
          <Button size="sm" variant="outline" onClick={onSicura} disabled={occupato}>
            <CheckCircle2 className="h-4 w-4 mr-1.5" /> L'ho controllata, è a posto
          </Button>
        )}
      </div>
    </div>
  );
}
